<script>
    import { fade } from 'svelte/transition';
    import FVHero from '../components/FVHero.svelte'
    import Centering from '../layouts/Centering.svelte'
    import Heading from '../components/Heading.svelte'
    import Button from '../components/LargeImgButton.svelte'
    import Slider from  '../widgets/Slider.svelte'
    const src = {
        pc:"img/info-fv.png",
        mb:"img/info-fv_mb.png"
    }
</script>
<svelte:head>
	<title>企業方針 | 株式会社有倉商店</title>
</svelte:head>
<div transition:fade>
    <FVHero images={src} />
    <div class="hd-layout">
    </div>
    <Centering>
        <div class="wrapper">
            <h2>プライバシーポリシー</h2>
            <table>
                <tr><th>基本方針</th><td>株式会社有倉商店（以下「当社」）は、以下のとおり個人情報保護方針を定め、個人情報保護の仕組みを構築し、全従業員に個人情報保護の重要性の認識と取組みを徹底させることにより、個人情報の保護を推進致します。</td></tr>
                <tr><th>個人情報の管理</th><td>当社はお客様の信頼を第一と考え、お客様の個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、セキュリティシステムの維持・管理体制の整備や社員教育の徹底など必要な措置を講じ、個人情報の厳重な管理を行います。</td></tr>
                <tr><th>1.個人情報の利用目的</th><td>お客様からお預かりした個人情報は、当社からのご連絡や業務のご案内、ご質問に対する回答として、電話、FAX、電子メールや資料の送付に利用いたします。</td></tr>
                <tr><th>2.個人情報の共同利用について</th><td>当社は上記1の利用目的達成のため、その必要範囲内において、お客様の個人情報を当社関連会社と共同利用する場合がございます。</td></tr>
                <tr><th>3.個人情報の委託について</th><td>当社は上記1の利用目的達成のため、その必要範囲内において、個人情報の取扱いに関する業務を、外部に委託する場合がございます。
                    この場合、当社は個人情報を適正に取り扱っていると認められる業務委託先を選定し、委託契約等により個人情報の安全管理に関する事項の取り決めをするとともに、必要かつ適切な監督を行います。</td></tr>
                <tr><th>4.個人情報の第三者への開示・提供の禁止</th><td>当社は上記1の利用目的達成のため、その必要範囲内において、個人情報の取扱いに関する業務を、外部に委託する場合がございます。
                    この場合、当社は個人情報を適正に取り扱っていると認められる業務委託先を選定し、委託契約等により個人情報の安全管理に関する事項の取り決めをするとともに、必要かつ適切な監督を行います。</td></tr>
                <tr><th>5.個人情報の安全対策</th><td>お客様からお預かりした個人情報は、当社からのご連絡や業務のご案内、ご質問に対する回答として、電話、FAX、電子メールや資料の送付に利用いたします。</td></tr>
                <tr><th>6.ご本人の照会確認</th><td>お客様がご本人の個人情報の照会・修正・削除などをご希望される場合には、ご本人であることを確認の上、対応させていただきます。</td></tr>
                <tr><th>7.法令・規範の遵守と見直し</th><td>当社は、保有する個人情報に関して適用される日本の法令、その他規範を遵守するとともに、本ポリシーの内容を適宜見直し、その改善に努めます。</td></tr>
            </table>    
        </div>

    </Centering>
</div>
<style>
    .hd-layout{
        margin-top: 75px;
    }
    h2{
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 24px;
        line-height: 41px;
        text-align: left;
        color: #000
    }
    table{
        margin-top: 60px;
        margin-bottom: 125px;
    }
    tr{
        display: flex;
        box-sizing: border-box;
        min-height: 54px;
        border-bottom:1px solid #959595;
    }
    th{
        width:417px;
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 24px;
        font-weight: bold;
        text-align: left;
        color: #000;
        justify-content: flex-start;
        line-height: 36px;
        padding: 15px 31px;
    }
    td{
        width: 587px;
        white-space: pre-line;
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 14px;
        text-align: left;
        color: #000;
        line-height: 36px;
        padding: 15px 0;
    }
    @media screen and (max-width:640px){
        .row{
            flex-direction: column;
        }
        table{
            display: block;
            width: 100%;
        }
        tr{
            flex-direction: column;
            width: 100%;
        }
        th{
            padding: 0;
            width: 100%;
            font-size: 14px;
        }
        td{
            width: 100%;
            white-space:initial;
            word-wrap: break-word;
            font-size: 14px;
        }
        h2{
            font-size: 16px;
        }
    }
</style>